import { KeyboardCloseOutlineIcon } from './KeyboardCloseOutlineIcon';

/**
 * author: mpardieck
 * id 6F1662E0-9571-4412-9075-6982D2636788
 * name keyboard-close-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-close-outline.svg
 * tags
 */
export const KeyboardHideOutlineIcon = KeyboardCloseOutlineIcon;
export default KeyboardHideOutlineIcon